/* eslint-disable camelcase */
export enum MonitoringRequestTypes {
  STATUS_MONITORING_REQUEST = '@monitoring/STATUS_MONITORING_REQUEST',
  STATUS_MONITORING_SUCCESS = '@monitoring/STATUS_MONITORING_SUCCESS',
  STATUS_MONITORING_FAILURE = '@monitoring/STATUS_MONITORING_FAILURE',
  ELECTRONICS_TRADINGS_REQUEST = '@monitoring/ELECTRONICS_TRADINGS_REQUEST',
  ELECTRONICS_TRADINGS_SUCCESS = '@monitoring/ELECTRONICS_TRADINGS_SUCCESS',
  ELECTRONICS_TRADINGS_FAILURE = '@monitoring/ELECTRONICS_TRADINGS_FAILURE',
  ELECTRONIC_TRADING_REQUEST = '@monitoring/ELECTRONIC_TRADING_REQUEST',
  ELECTRONIC_TRADING_SUCCESS = '@monitoring/ELECTRONIC_TRADING_SUCCESS',
  ELECTRONIC_TRADING_FAILURE = '@monitoring/ELECTRONIC_TRADING_FAILURE',
  DESTROY_ELECTRONICS_TRADINGS_REQUEST = '@monitoring/DESTROY_ELECTRONICS_TRADINGS_REQUEST',
  DESTROY_ELECTRONICS_TRADINGS_SUCCESS = '@monitoring/DESTROY_ELECTRONICS_TRADINGS_SUCCESS',
  DESTROY_ELECTRONICS_TRADINGS_FAILURE = '@monitoring/DESTROY_ELECTRONICS_TRADINGS_FAILURE',
  TRADING_MESSAGES_REQUEST = '@monitoring/TRADING_MESSAGES_REQUEST',
  TRADING_MESSAGES_SUCCESS = '@monitoring/TRADING_MESSAGES_SUCCESS',
  TRADING_MESSAGES_FAILURE = '@monitoring/TRADING_MESSAGES_FAILURE',
  UPDATE_TRADING_MESSAGES = '@monitoring/UPDATE_TRADING_MESSAGES',
  READ_MESSAGES = '@monitoring/READ_MESSAGES',
  INTEREST_LOTS_REQUEST = '@monitoring/INTEREST_LOTS_REQUEST',
  INTEREST_LOTS_SUCCESS = '@monitoring/INTEREST_LOTS_SUCCESS',
  INTEREST_LOTS_FAILURE = '@monitoring/INTEREST_LOTS_FAILURE',
  SAVE_INTEREST_LOTS_REQUEST = '@monitoring/SAVE_INTEREST_LOTS_REQUEST',
  SAVE_INTEREST_LOTS_SUCCESS = '@monitoring/SAVE_INTEREST_LOTS_SUCCESS',
  SAVE_INTEREST_LOTS_FAILURE = '@monitoring/SAVE_INTEREST_LOTS_FAILURE',
  GET_TRADING_KEYWORDS_REQUEST = '@monitoring/GET_TRADING_KEYWORDS_REQUEST',
  GET_TRADING_KEYWORDS_SUCCESS = '@monitoring/GET_TRADING_KEYWORDS_SUCCESS',
  GET_TRADING_KEYWORDS_FAILURE = '@monitoring/GET_TRADING_KEYWORDS_FAILURE',
  SAVE_TRADING_KEYWORDS_REQUEST = '@monitoring/SAVE_TRADING_KEYWORDS_REQUEST',
  SAVE_TRADING_KEYWORDS_SUCCESS = '@monitoring/SAVE_TRADING_KEYWORDS_SUCCESS',
  SAVE_TRADING_KEYWORDS_FAILURE = '@monitoring/SAVE_TRADING_KEYWORDS_FAILURE',
  DELETE_TRADING_KEYWORDS_REQUEST = '@monitoring/DELETE_TRADING_KEYWORDS_REQUEST',
  DELETE_TRADING_KEYWORDS_SUCCESS = '@monitoring/DELETE_TRADING_KEYWORDS_SUCCESS',
  DELETE_TRADING_KEYWORDS_FAILURE = '@monitoring/DELETE_TRADING_KEYWORDS_FAILURE',
  UPDATE_TRADING_KEYWORD_REQUEST = '@monitoring/UPDATE_TRADING_KEYWORD_REQUEST',
  UPDATE_TRADING_KEYWORD_SUCCESS = '@monitoring/UPDATE_TRADING_KEYWORD_SUCCESS',
  UPDATE_TRADING_KEYWORD_FAILURE = '@monitoring/UPDATE_TRADING_KEYWORD_FAILURE',
  MARK_AS_READ_REQUEST = '@monitoring/MARK_AS_READ_REQUEST',
  MARK_AS_READ_SUCCESS = '@monitoring/MARK_AS_READ_SUCCESS',
  MARK_AS_READ_FAILURE = '@monitoring/MARK_AS_READ_FAILURE',
  GET_APPEALS_REQUEST = '@monitoring/GET_APPEALS_REQUEST',
  GET_APPEALS_SUCCESS = '@monitoring/GET_APPEALS_SUCCESS',
  GET_APPEALS_FAILURE = '@monitoring/GET_APPEALS_FAILURE',
  GET_APPEALS_NOTIFICATIONS_REQUEST = '@monitoring/GET_APPEALS_NOTIFICATIONS_REQUEST',
  GET_APPEALS_NOTIFICATIONS_SUCCESS = '@monitoring/GET_APPEALS_NOTIFICATIONS_SUCCESS',
  GET_APPEALS_NOTIFICATIONS_FAILURE = '@monitoring/GET_APPEALS_NOTIFICATIONS_FAILURE',
  GET_NOTIFICATIONS_UNREAD_REQUEST = '@monitoring/GET_NOTIFICATIONS_UNREAD_REQUEST',
  GET_NOTIFICATIONS_UNREAD_SUCCESS = '@monitoring/GET_NOTIFICATIONS_UNREAD_SUCCESS',
  GET_NOTIFICATIONS_UNREAD_FAILURE = '@monitoring/GET_NOTIFICATIONS_UNREAD_FAILURE',
  GET_MONITORED_ELECTRONIC_TRADING_IDS_REQUEST = '@monitoring/GET_MONITORED_ELECTRONIC_TRADING_IDS_REQUEST',
  GET_MONITORED_ELECTRONIC_TRADING_IDS_SUCCESS = '@monitoring/GET_MONITORED_ELECTRONIC_TRADING_IDS_SUCCESS',
  GET_MONITORED_ELECTRONIC_TRADING_IDS_FAILURE = '@monitoring/GET_MONITORED_ELECTRONIC_TRADING_IDS_FAILURE',
  MARK_APPEAL_AS_READ_REQUEST = '@monitoring/MARK_APPEAL_AS_READ_REQUEST',
  MARK_APPEAL_AS_READ_SUCCESS = '@monitoring/MARK_APPEAL_AS_READ_SUCCESS',
  MARK_APPEAL_AS_READ_FAILURE = '@monitoring/MARK_APPEAL_AS_READ_FAILURE',
  TOGGLE_IMPORTANT_REQUEST = '@monitoring/TOGGLE_IMPORTANT_REQUEST',
  TOGGLE_IMPORTANT_SUCCESS = '@monitoring/TOGGLE_IMPORTANT_SUCCESS',
  TOGGLE_IMPORTANT_FAILURE = '@monitoring/TOGGLE_IMPORTANT_FAILURE',
  ARCHIVE_REQUEST = '@monitoring/ARCHIVE_REQUEST',
  ARCHIVE_SUCCESS = '@monitoring/ARCHIVE_SUCCESS',
  ARCHIVE_FAILURE = '@monitoring/ARCHIVE_FAILURE',
  DISABLE_NOTIFICATIONS = '@monitoring/DISABLE_NOTIFICATIONS',
  ENABLE_NOTIFICATIONS = '@monitoring/ENABLE_NOTIFICATIONS',
  UPDATE_STORE_FIELDS = '@monitoring/UPDATE_STORE_FIELDS',
  UPDATE_CURRENT_PAGE = '@monitoring/UPDATE_CURRENT_PAGE',
  UPDATE_CURRENT_SOURCE_ID = '@monitoring/UPDATE_CURRENT_SOURCE_ID',
  HANDLE_FILTER_BY = '@monitoring/HANDLE_FILTER_BY',
  ADD_MONITORED_BY = '@monitoring/ADD_MONITORED_BY',
  REMOVE_MONITORED_BY = '@monitoring/REMOVE_MONITORED_BY',
}

export type MonitoringFilter = 'all' | 'unread' | 'important' | 'archived';
export interface BiddingTypes {
  id: number;
  orgao_id: number;
  edital: string;
  datahora_prazo: null | string;
  datahora_abertura: null | string;
  datahora_visita: null | string;
  datahora_documento: null | string;
  datahora_retirada: null | string;
  objeto: string;
  public_body: {
    nome: string;
    uasg: string;
  };
  bidding_grouping: {
    descricao: string;
  };
}

export interface MonitoredByTypes {
  id: number;
  nome: string;
  acronym_name: string;
}

export interface MonitoredByCompanyTypes {
  id: number;
  nome: string;
  visivel?: boolean;
  proprio?: boolean;
  arquivado?: boolean;
  importante?: boolean;
  bloqueio?: string | null;
}

export interface MonitoringBiddingTypes {
  id: number;
  trading_situation: string;
  trading_id: string;
  source_id: number;
  trading_status_id: number;
  bidding_id: number;
  initial_date: string;
  final_date: string;
  created_at: string;
  updated_at: string;
  edital: null | string;
  bidding_url: null | string;
  uasg: string;
  previous_trading_status_id: number;
  trading_extract_url: string;
  last_message_time: string;
  lots: Array<number>;
  monitored_by: Array<MonitoredByTypes>;
  monitored_by_companies?: Array<MonitoredByCompanyTypes>;
  monitored_company_id?: number | null;
  have_messages: boolean;
  bidding: BiddingTypes;
  have_new_messages: boolean;
  have_new_messages_lots: Array<number>;
  important: boolean;
  archived: boolean;
}

export interface TradingMessageTypes {
  id: number;
  message_holder: string;
  message_time: string;
  message_highlight: string;
  lot: number | null;
  electronic_trading_id: number;
  message: string;
}

export interface MonitoringMessagesTypes {
  [key: string]: Array<TradingMessageTypes>;
}

export interface InterestLotTypes {
  created_at: string;
  electronic_trading_id: number;
  id: number;
  lot: number;
  updated_at: string;
  user_id: number;
}

export interface InterestLotsTypes {
  [key: string]: Array<InterestLotTypes>;
}

export interface TradingKeywordTypes {
  id: number;
  contact_client_id: number;
  keyword: string;
  created_at: string;
  updated_at: string;
  priority?: 'alta' | 'media' | 'baixa';
  notify_sound?: boolean;
  notify_push?: boolean;
  active?: boolean;
}

export interface AppealTypes {
  created_at: string;
  electronic_trading_id: number;
  id: number;
  lot: number;
  message: string;
  session: number;
  updated_at: string;
  url: string | null;
}

export interface AppealsTypes {
  [key: string]: Array<AppealTypes>;
}

export interface AppealNotificationsTypes {
  acting_as: {
    actable_id: number;
    actable_type: string;
    created_at: string;
    id: number;
    read: boolean;
    updated_at: string;
    user_id: number;
  };
  appeal_created_at: string;
  appeal_id: number;
  appeal_progress_id: null;
  created_at: string;
  electronic_trading_id: number;
  id: number;
  lot: number;
  read: false;
  session: number;
  updated_at: string;
  user_id: number;
}

export interface MonitoredElectronicTradings {
  [key: string]: Array<number>;
}

export interface MonitoringTypes {
  monitoring_status:
    | 'ok'
    | 'accept'
    | 'expired_trial'
    | 'disabled_service'
    | 'blocked_subscription'
    | 'overdued_subscription';
  electronics_tradings: Array<MonitoringBiddingTypes>;
  monitoring_messages: MonitoringMessagesTypes;
  interest_lots: InterestLotsTypes;
  trading_keywords: { [key: string]: Array<TradingKeywordTypes> };
  appeals: AppealsTypes;
  appeals_notifications: Array<AppealNotificationsTypes>;
  notifications_unread: boolean;
  disable_notifications: boolean;
  electronics_tradings_total_entries: number;
  electronics_tradings_total_pages: number;
  monitored_source_id_list: Array<number>;
  current_page: number;
  current_source_id: number[];
  filtered_by: 'by_me' | 'by_all';
  monitored_electronic_tradings: MonitoredElectronicTradings;
  current_filter_type: 'all' | 'archived' | 'important' | 'unread';
}

export interface BaseRequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  monitoring_status: BaseRequestState;
  electronics_tradings: BaseRequestState;
  delete_electronic_trading: BaseRequestState;
  monitoring_messages: BaseRequestState;
  interest_lots: BaseRequestState;
  get_trading_keywords: BaseRequestState;
  get_trading_keywords_representant: BaseRequestState;
  save_trading_keywords: BaseRequestState;
  save_trading_keywords_representant: BaseRequestState;
  delete_trading_keywords: BaseRequestState;
  get_appeals: BaseRequestState;
  get_appeals_notifications: BaseRequestState;
  get_notifications_unread: BaseRequestState;
  get_monitored_electronic_trading_ids: BaseRequestState;
}

export interface MonitoringState {
  readonly monitoring: MonitoringTypes;
  readonly request: RequestState;
}
